import { Injectable, OnDestroy } from '@angular/core';
import { AngularFirestoreCollection } from "@angular/fire/firestore";
import { Observable, Subscription, of } from "rxjs";
import { FirestoreService } from "@shared/services/firestore.service";
import { tap , shareReplay } from "rxjs/operators";

export interface Settings {
  brands: [],
  types: []
}

export interface Enhancement {
  name: string;
  price: number;
  description? : string
  image? : string
}

@Injectable({
  providedIn: 'root'
})
export class ProductsService implements OnDestroy {
  productsSub: Subscription;
  productsCollection: AngularFirestoreCollection<Settings>;
  products$: Observable<any>;
  availableBrands$: Observable<{name: string, logoUrl: string, isCustom: boolean, enabled: boolean}[]>;
  types$: Observable<any[]>;
  enhancements$: Observable<Enhancement[]>;

  availableTonnages = [0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,6.5,7,7.5,10];

  staticBrandsList = [
    "Air Con",
    "Amana",
    "American Standard",
    "Ameristar",
    "Arcoaire",
    "Armstrong Air",
    "Bard",
    "Bosch",
    "Bryant",
    "Carrier",
    "Climate Master",
    "Coleman",
    "Comfort Aire",
    "Comfortmaker",
    "Daikin",
    "Day and Night",
    "Ducane",
    "First Co",
    "Friedrich",
    "Frigidaire",
    "Fujitsu",
    "Gibson",
    "Goodman",
    "Gree",
    "Heil",
    "Janitrol",
    "LG",
    "Lennox",
    "Liberty",
    "Luxaire",
    "MITSUBISHI",
    "Maytag",
    "Nordyne",
    "Panasonic",
    "Payne",
    "Rheem",
    "Ruud",
    "Samsung",
    "Sanyo",
    "Tappan",
    "Tempstar",
    "Toshiba",
    "Trane",
    "Water Furnace",
    "Weather King",
    "Weil McLain",
    "Westinghouse",
    "Whirlpool",
    "York"
  ]

  constructor(
    public database: FirestoreService
  ) {

    this.products$ = this.database.doc$('products/settings').pipe(
      tap(), shareReplay({bufferSize: 1, refCount: true})
    );


    this.productsSub = this.products$.subscribe(
      settings => (
        this.availableBrands$ = of(settings?.availableBrands?.filter(brand => brand.enabled)),
        this.types$ = of(settings.types),
        this.enhancements$ = of(settings.enhancements)
      )
    )

  }

  ngOnDestroy() {
    this.productsSub.unsubscribe()
  }

}
